import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IExecutiveSummaryData } from '../../../features/maps/interfaces/executive-summary-response.model';

@Component({
    selector: 'lynkd-pattern-executive-summary-table',
    templateUrl: './executive-summary-table.component.html',
    styleUrls: ['./executive-summary-table.component.scss']
})
export class ExecutiveSummaryTableComponent {
    @Input() public data: Array<IExecutiveSummaryData> = [];
    @Input() public totals: IExecutiveSummaryData | null = null;
    @Input() public loading: boolean = false;
    @Input() public pageNumber: number = 1;
    @Input() public pageSize: number = 50;
    @Input() public totalRows: number = 0;

    @Output() public readonly pageChange: EventEmitter<number> = new EventEmitter<number>();

    public formatNumber(value: number | null): string {
        if (value === null || value === undefined) {
            return '-';
        }
        return value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }

    public formatPercentage(value: number | null): string {
        if (value === null || value === undefined) {
            return '-';
        }
        return value.toFixed(2) + '%';
    }

    public formatCurrency(value: number | null): string {
        if (value === null || value === undefined) {
            return '-';
        }
        return 'R' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    public onPageChange(pageIndex: number): void {
        this.pageChange.emit(pageIndex);
    }
}
